
import React, { Component } from "react";
import { FileUploader } from "react-drag-drop-files";
import {
  Col,
  Row,
  Card,
  Form,
  Button,
  InputGroup,
  Container,
} from "@themesberg/react-bootstrap";
import img1 from "../assets/img/INTGG2187.jpg";
import img2 from "../assets/img/img2.PNG";
import logo from "../assets/img/logo.png";
import md1 from "../assets/img/ma1.PNG"
import md2 from "../assets/img/ma2.PNG"
import img3 from "../assets/img/CO2.png"
import img4 from "../assets/img/rain_drop.png"
import img5 from "../assets/img/temperature.png"
import img6 from "../assets/img/Leaf-01.png";
import curve from "../assets/img/CURVE-01.png"
import img7 from "../assets/img/farm-tree.png"
import QACode from "../assets/img/QA Code.PNG";
import { faWindows } from "@fortawesome/free-brands-svg-icons";
import config from "../config/axios/config.json";
import "../components/Certificate.css";
import longtree from "../assets/img/INTGG1971.jpg"
import shorttree from "../assets/img/INTGG2187.jpg"
import co2 from "../assets/img/Green Gift Certificate-03.png"
import drop from "../assets/img/Green Gift Certificate-04.png"
import temp from "../assets/img/Green Gift Certificate-05.png"

const Mode = config.Application.mode;
const APIURL = config["CommonConstants"].web[Mode];
var QRCode = require("qrcode.react");
// const Cryptr = require("cryptr");

export default class Certificate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FilteredUserList: props.value || {
        CustomerName: "",
        CarbonConsumption: "",
        Rainfall: "",
        AtmosphericTemp: "",
        CertNo: "",
        ID: ""
      },
    };
  }

  //componentDidMount() {
  // let URl = "http://localhost:3000/#/Certificate?ID="
  // let encryptedString = "e7b75a472b65bc4a42e7b3f78833a4d00040beba796062bf7c13d9533b149e5ec3784813dc20348fdf248d28a2982df85b83d1109623bce45f08238f6ea9bd9bb5f406427b2a40f969802635b8907a0a57944f2c12f334bd081d5143a357c173a611e1b64a"
  // const cryptr = new Cryptr("myTotalySecretKey");
  // const decryptedString = cryptr.decrypt(encryptedString);
  // getuser(`${APIURL.API_URL}/QRCode/read`)
  // .then((response) => {
  //   if (response.isSuccess) {
  //     this.setState({FilteredUserList:response.data.filter((a,b) => a.ID = parseInt(decryptedString))[0]})
  //   }
  // })
  // .catch((e) => {
  //   console.log("Error", e);
  // });

  // }

  render() {
    const nameLength = this.state.FilteredUserList?.CustomerName?.length || 0;
    return (
      <>
        <div className="ccertificate-container">
          <div className="ccertificate-box">

            {/* Top Left Banner */}
            <div className="top-header">
              <div className="certbanner">
                <div>Wishing you a
                prosperous 2026!</div>
              </div>

              {/* Top Right Logo */}
              <div className="logo">
                <img src={logo} class="logoImg" alt="Logo" />
              </div>
            </div>


            <div className="certcontent">

              {/* Left Content */}
              <div className="left-section">
                <div className="dear">{this.state.FilteredUserList.CertNo == "INTGG2417" ? "To" : "Dear"}</div>
                <div
                  className="name"
                  style={{
                    fontSize:
                      nameLength > 0 ?
                        nameLength < 20
                          ? "56px"
                          : nameLength < 30
                            ? "48px"
                            : nameLength < 40
                              ? "48px"
                              : "35px"
                        : "35px",
                    lineHeight: 1
                  }}
                >
                  {"GR Ananthapadmanabhan, M rs. R"}
                </div>

                <div className="dotted-line"></div>

                <div className="message">
                  Thank you for becoming part of our sustainable future. As we step into 2026,
                  we wish you a year of health, growth, and progress.
                </div>
                <div className="signature-section" style={{
                  marginBottom:
                    nameLength < 20
                      ? "60px"
                      : nameLength < 30
                        ? "50px"
                        : "40px",
                }}>

                  <div className="signatures">
                    <div>
                      <span className="signature-sign sign1 signature-line">
                        SRIRAM SUBRAMANYA
                      </span>
                    </div>

                    <div style={{ marginBottom: "10px" }}>
                      <span className="signature-sign sign1 signature-line">
                        ANU SRIRAM
                      </span>
                    </div>
                  </div>

                  <div className="signatures">
                    <div >
                      <div className="signature-font" style={{ marginLeft: "30px", marginTop: "10px" }}>Founder, MD & CEO</div>
                    </div>

                    <div>
                      <div className="signature-font" style={{ marginTop: "10px" }}>Co-founder & JMD</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Image */}
              <div className="right-section">
                <img
                  src={`https://qrgreencode.blob.core.windows.net/qrcode/QRCode/${this.state.FilteredUserList.CertNo}.jpg`}
                  alt="Tree"
                  className="tree-image"
                />
              </div>

            </div>
          </div>
        </div>

        <div className="page2">

          {/* Border */}
          <div className="page2-border">

            {/* Logo */}
            <div className="page2-logo">
              <img src={logo} class="logoImg logoImg2" alt="Logo" />
            </div>

            <div className="page2-content">

              {/* LEFT GREEN PANEL */}
              <div className="green-panel">

                <p className="panel-title">
                  A remarkable species, your tree boosts the environment in significant ways
                </p>

                <div className="stats">
                  <div className="stat">
                    <img className="icon" src={co2} alt="co2" width={50} height={50} />
                    <p>
                      It actively absorbs around {this.state.FilteredUserList.CarbonConsumption} pounds of carbon dioxide annually
                      and provides life-sustaining oxygen.
                    </p>
                  </div>

                  <div className="stat">
                    <img className="icon" src={drop} alt="droplet" width={50} height={50} />
                    <p>
                      By intercepting roughly {this.state.FilteredUserList.Rainfall} gallons of rainfall annually,
                      it contributes significantly to water conservation efforts.
                    </p>
                  </div>

                  <div className="stat">
                    <img className="icon" src={temp} alt="co2" width={50} height={50} />
                    <p>
                      It effectively reduces the local temperature by {this.state.FilteredUserList.AtmosphericTemp} degrees,
                      creating a more pleasant atmosphere.
                    </p>
                  </div>
                </div>

                <div className="tree-info">
                  <p>
                    Mahogany is a deciduous tree characterized by leaves arranged in a spiral
                    formation, clustered at the ends of branches. The wood from the tree is
                    commonly used for making furniture. Its bitter-tasting bark is employed
                    for various medicinal purposes, including treating malaria-induced fever,
                    stomach complaints and headaches. Externally, it is applied to heal skin
                    rashes, wounds and other abnormalities.
                  </p>
                </div>

              </div>

              {/* RIGHT SIDE */}
              <div className="right-panel">
                <img
                  src={`https://qrgreencode.blob.core.windows.net/qrcode/QRCode/${this.state.FilteredUserList.CertNo}_2.jpg`}
                  alt="Tree"
                  className="tree-photo"
                />

                <div className="qr-section">
                  <a href={`https://integraforest.com/UserPage/?id=${btoa(this.state.FilteredUserList.ID)}`}>
                    <QRCode
                      value={`https://integraforest.com/UserPage/?id=${btoa(this.state.FilteredUserList.ID)}`}
                      style={{
                        width: "110px",
                        height: "110px",
                        position: "relative",
                        backgroundColor: "#fff",
                      }}
                    ></QRCode>
                  </a>
                  <p>Experience Your<br />
                    New Digital Certificate</p>
                </div>
              </div>

            </div>
          </div>
        </div>



        {/* <!-- Second Page --> */}

      </>
    );
  }
}
